import type { ReactNode } from "react";

/**
 * AuthShell es el contenedor mobile-first de las pantallas de autenticación:
 * fondo de alto contraste, marca y la tarjeta centrada con el formulario.
 * El logotipo corporativo solo aparece aquí: es teal oscuro sobre transparente
 * y necesita el fondo claro para leerse (en la cabecera navy no contrastaría).
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-slate-100 px-4 py-8">
      <div className="flex flex-col items-center gap-3">
        <img src="/logo-levitec.png" alt="Levitec" className="h-12 w-auto" />
        <span className="font-bold text-slate-900 text-xl tracking-tight">LOTO System</span>
      </div>
      <div className="w-full max-w-md">{children}</div>
    </main>
  );
}
